<template>
    <div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <div class="TTL-select">
            <el-select v-model="param.type" placeholder="请选择宠物类型" @change="param.ischange=true" clearable filterable>
            <el-option v-for="(item,index) in typelist" :key="index" :label="item.name" :value="item.id" />
            </el-select>
            </div>
        </el-form-item>
        <el-form-item>
            <div class="TTL-select">
            <el-select v-model="param.timetype" placeholder="请选择搜索时间类型" @change="param.ischange=true" clearable filterable>
            <el-option v-for="(item,index) in timetypelist" :key="index" :label="item.name" :value="item.id" />
            </el-select>
            </div>
        </el-form-item>
        <el-form-item>
        <div class="TTL-datetime">
        <el-date-picker
            v-model="param.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD"
            @change="param.ischange=true"
        />
        </div>
        </el-form-item>
        <el-form-item>
        <div class="TTL-input">
        <el-input v-model="param.key" placeholder="请输入宠物名称" clearable @keydown.enter.prevent="GetNestInfos" @change="param.ischange=true" />
        </div>
        </el-form-item>
        <el-form-item>
        <div class="TTL-button">
        <el-button @click="GetNestInfos">搜索</el-button>
        </div>
        </el-form-item>
        <el-form-item>
        <div class="TTL-button">
        <el-button @click="AddPetNest">添加窝次</el-button>
        </div>
        </el-form-item>

    </el-form>
    </div>

    <div class="TTL-table top20" id="table-nest-obj">
        <el-table :data="list" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column type="expand" >
                <template #default="scope">
                    <el-table :data="scope.row.child" stripe="true" empty-text="">
                        <template v-slot:empty><el-empty description="暂无数据" /></template>
                        <el-table-column label="繁育宠物" align="center">
                            <template #default="tcope">
                                <div class="TTL-pet-image">
                                <el-image 
                                :src="tcope.row.child_pet_thumb ? tcope.row.child_pet_thumb : require('@/assets/icon/pet-upload-default.png')" 
                                fit="cover" 
                                class="TTL-image-box-small"
                                />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="child_pet_name" label="宠物名称" align="center" />
                        <el-table-column label="性别" prop="sex_name" align="center" />
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column label="宠物信息" align="left" min-width="180">
                <template #default="scope">
                    <div class="TTL-birth-box">
                        <div class="TTL-birth-info">
                            <div class="TTL-pet-image">
                            <el-image :src="scope.row.boy_pet_thumb ? scope.row.boy_pet_thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-small"/>
                            </div>
                            <span class="TTL-birth-name">{{scope.row.boy_pet_name ? scope.row.boy_pet_name : '宠物粑粑'}}<h>{{scope.row.boy_type_name ? '（'+scope.row.boy_type_name+'）' : ''}}</h></span>  
                            <div class="manorwoman"><el-image :src="require('@/assets/icon/man.png')" /></div>
                        </div>
                        <div class="compare"><el-image :src="require('@/assets/icon/compare.png')" /></div>
                        <div class="TTL-birth-info">
                            <div class="TTL-pet-image">
                            <el-image :src="scope.row.girl_pet_thumb ? scope.row.girl_pet_thumb : require('@/assets/icon/pet-upload-default.png')" fit="cover" class="TTL-image-box-small"/>
                            </div>
                            <span class="TTL-birth-name">{{scope.row.girl_pet_name ? scope.row.girl_pet_name : '宠物粑粑'}}<h>{{scope.row.girl_type_name ? '（'+scope.row.girl_type_name+'）' : ''}}</h></span>  
                            <div class="manorwoman"><el-image :src="require('@/assets/icon/woman.png')" /></div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="宠物类型" prop="typename" align="center" />
            <el-table-column label="交配时间" prop="loveday" align="center" min-width="120"/>
            <el-table-column label="生产时间" prop="expireday" align="center" min-width="120"/>
            <el-table-column label="操作" align="center" fixed="right" min-width="200">
                <template #default="scope">
                    <div class="TTL-button">
                    <el-button @click="EditPetNest(scope.row.id)">编辑</el-button>
                    <el-button type="del" @click="DelNest(scope.row.id)">删除</el-button>
                    </div>
                </template>
            </el-table-column>

        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <el-select v-model="handlevalue" placeholder="请选择操作" clearable @change="changehandle">
                    <el-option v-for="(item,index) in handleinfos" :key="index" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="TTL-page TTL-page-right">
                <el-pagination
                    @current-change="changepage"
                    @size-change="changesize"
                    v-model:current-page="param.p"
                    v-model:page-size="param.rollpage"
                    :page-sizes="[20,40,60,100]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="param.rows"
                />
            </div>
        </div>
    </div>
</template>

<script>
import INTERFACE_MODEL_BIRTH from '@/Interface/Pets/Birth';
import INTERFACE_MODEL_PETS from '@/Interface/Pets/Pets';
import INTERFACE_MODEL_NEST from '@/Interface/Pets/Petnest';
export default {
    components:{},
    data() {
        return {
            param: {
                type:'',
                timetype:'',
                time:'',
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0
            },
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除繁育'},
                {id:2,name:'批量修改繁育'},
            ],
            typelist:[],
            timetypelist:[
                {id:1,name:'按交配日期搜索'},
                {id:2,name:'按生产日期搜索'},
            ],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetPetTypelist();    //获取宠物类型
            this.GetNestInfos();     //获取繁育信息列表
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {              //组件已存在，同级兄弟元素调用时产生的操作
                this.GetNestInfos();     //获取宠物繁育信息列表
            }else if(data.reload) {       //浏览器重新刷新时执行的操作
                
            }
        },


        /** 批量操作 **/
        changehandle(index) {
            this.handlevalue='';
            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {

               var ids=this.GetSelectDataIds();
               if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的宠物',type:'warning'});return false;}
               if(index==1) { //批量删除宠物
                   this.DelNestInfos(ids.join(',')); 

               }else if(index==2) { //批量修改宠物类型
                   this.GoEditPetNest(ids.join(','));
               }

            }).catch(()=> {
                
            });
        },


        /** 编辑提醒信息 **/
        EditPetNest(id) {
            this.GoEditPetNest(id);
        },


        /** 删除提醒 **/
        DelNest(id) {
            this.DelNestInfos(id);
        },


        //删除繁育信息
        DelNestInfos(ids) {
            INTERFACE_MODEL_NEST.DEL_NEST({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetNestInfos();
            });
        },


        ///////////////////////////////////////
        ///////////////////////////////////////
        //加载宠物信息列表

         /** 获取宠物类型 **/
        GetPetTypelist() {
            INTERFACE_MODEL_PETS.GET_PET_Types({}).then((res) => {
                 if(res.status > 0) return false;
                 this.typelist=res.data;
            });
        },


        /** 获取宠物信息列表 **/
        GetNestInfos() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-nest-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_NEST.GET_NEST_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
                 this.$forceUpdate(); //强制渲染页面
            });
        },

        /** 修改当前页数 **/
        changepage(p) {
            this.param.p=p;
            this.GetNestInfos();
        },

        changesize(rollpage) {
            this.param.rollpage=rollpage;
        },

        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.list.length;i++) this.list[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.list);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.list.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


         /** 添加窝次信息 **/
        AddPetNest() {
            var navinfo={name:'新增窝次',labelentry:'AddPetNest',components:'AddPetNest',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑繁育信息 **/
        GoEditPetNest(ids) {
            var navinfo={name:'编辑窝次',labelentry:'EditPetNest',components:'EditPetNest',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        //加载宠物信息列表
        ///////////////////////////////////////
        ///////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-pet-infos {display: flex;align-items: center;}
.TTL-pet-infos-content {display:inline-block;width:calc(100% - 80px);margin-left:20px;}
.TTL-pet-infos-content-info {display: inline-flex;align-items: center;width:100%;}
.TTL-pet-infos-content-item {display:inline-block;color:#666666;background-color: #DCDFE6;padding:7px 15px 5px 15px;font-size:12px;line-height:12px;border-radius: 20px;margin:0 10px 5px 0;zoom:.9;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-birth-box {display:inline-flex;align-items:center;}
.TTL-birth-info {display:inline-block;width:60px;text-align: center;position:relative;}
.manorwoman {position:absolute;top:0;right:0;width:22px;height:22px;padding:5px;background-color: #ffffff;border-radius: 50%;}
.TTL-birth-name {font-size:12px;}
.compare {display:inline-block;width:22px;height: 22px;margin:-20px 20px 0 20px;}
.TTL-birth-btd i {font-style: normal;color:#cf0f45;padding:0 10px;font-size:13px;font-weight: 600;}
</style>